/* eslint-disable react/jsx-no-duplicate-props */
import { Alert, Descriptions, Divider, Modal } from 'antd';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getUpdate, postCreate, PutUpdate } from 'components/Data';
import InputClock from 'components/inputs/InputClock';
import InputControl from 'components/inputs/InputControl';
import InputControlAsync from 'components/inputs/InputControlAsync';
import InputDate from 'components/inputs/InputDate';
import InputPricing from 'components/inputs/InputPricing';
import InputControlMulti from 'components/inputs/InputControlMulti';
import Switchrs from 'components/inputs/Switchrs';
import Loader from 'components/layout/Loader';
import DashboardContext from 'Context';
import FormGroupoption from './FormGroupoption';
import FormPreiod from './FormPreiod';
import FormsetGroup from './FormsetGroup';
import ModalAddCoustmer from './ModalAddCoustmer';
import B2BAmountPerHourInfo from './B2BAmountPerHourInfo';
import toaster from 'helper/toaster';
/**
 * این کامپوننت برای نمایش فرم ثبت سفارش است
 * در پروفایل مشتری نیرو و صفحه سفارشات استفاده شده است
 */
const FormOrder = ({ userprofile }) => {
  const {
    authentication,
    urldashboard,
    handelAdd,
    edit,
    handelloding,
    handelEdit,
    loding,
    handeldmicro,
    handelerrors,
    handelEditOrder,
  } = useContext(DashboardContext);

  const [dataFromGrpoup, setDataFromGrpoup] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);

  const handeldatafromgroup = (data) => {
    setDataFromGrpoup(data);

    handelsetdataForm({ ...formdata, ...data });
  };

  const [preiod, setPreiod] = useState(false);

  const handelpreiod = (status) => setPreiod(status);

  const [addressId, setAddressId] = useState('');

  const [datapreiod, setDatapreiod] = useState({});

  const handelPreiodForm = (data) => {
    setDatapreiod(data);
    handelsetdataForm({ ...formdata, ...data });
  };

  const [dataFromGroupOption, setDataFromGroupOption] = useState([]);

  const handelGroupOption = (item) => {
    setDataFromGroupOption(item);
    handelsetdataForm({ ...formdata, orderOptions: item });
  };

  const [startDate, setStartDate] = useState('');

  const [startclock, setStartclock] = useState('');

  const [LoadingForm, setLoadingForm] = useState(false);

  const [dataUpdate, setDataUpdate] = useState({});

  const [formdata, setFormdata] = useState({
    isActive: true,
    userId: userprofile ? userprofile : '',
    paymentType: 4,
    orderType: 2,
    confirmByCustomer: true,
    commission: 0,
    needServicePointOn: true,
    needServicePointOff: true,
    servicePointOn: [],
    servicePointOff: [],
  });

  const handelsetdataForm = (object) => setFormdata(object);

  const handelLoadingform = (item) => setLoadingForm(item);

  const newFormData = {
    ...formdata,
    addressId: addressId,
    substituteUserId: formdata?.userId,
    addressServicePointRequests: [
      {
        addressServicePoints: formdata?.needServicePointOn
          ? formdata?.servicePointOn?.map((item) => {
              return {
                id: item,
                isCompleteCapacity: false,
              };
            })
          : [],
        noNeedServicePoint: !formdata?.needServicePointOn,
        transportationLineType: 0,
      },
      {
        addressServicePoints: formdata?.needServicePointOff
          ? formdata?.servicePointOff?.map((item) => {
              return {
                id: item,
                isCompleteCapacity: false,
              };
            })
          : [],
        noNeedServicePoint: !formdata?.needServicePointOff,
        transportationLineType: 1,
      },
    ],
  };

  const handelSend = async () => {
    const isValid = newFormData?.addressServicePointRequests?.every(
      (item) =>
        item?.noNeedServicePoint || item?.addressServicePoints?.length > 0
    );

    if (!isValid) {
      return toaster?.error(
        'لطفا نقطه سرویسهای مورد نظر را در صورت نیاز وارد کنید.'
      );
    }

    handelLoadingform(true);

    await postCreate(
      `${urldashboard}/BusinessToBusinessOrder/create`,
      authentication,
      newFormData,
      handelLoadingform,
      handelAdd,
      handeldmicro,
      handelerrors
    );

    handelLoadingform(false);
  };

  const handelUpdataFrom = async () => {
    handelLoadingform(true);
    await PutUpdate(
      `${urldashboard}/BusinessToBusinessOrder/update`,
      newFormData,
      authentication,
      handelLoadingform,
      handelEdit,
      handelAdd,
      handeldmicro,
      handelerrors,
      userprofile,
      handelEditOrder
    );
    handelLoadingform(false);
  };

  const dataFeching = async () => {
    await getUpdate(
      `${urldashboard}/BusinessToBusinessOrder/update/${edit}`,
      authentication,
      handelloding,
      handelAdd,
      handelEdit,
      handelDataUpdate,
      handeldmicro,
      handelerrors
    );
  };

  const handelDataUpdate = (data) => {
    setDataFromGroupOption(data.orderOptions);
    setStartDate(
      data.hasOwnProperty('startWork') ? data.startWork.split('T')[0] : ''
    );
    setStartclock(
      data.hasOwnProperty('startWork') ? data.startWork.split('T')[1] : ''
    );
    setAddressId(data.addressId);

    setEditMode(true);

    setDataUpdate(data);
    setFormdata(data);
  };

  //userCatemodalData
  const [MobileUser, setMobileUser] = useState();

  const [idUserCreate, setIdUserCreate] = useState();

  const setiduserCrate = (data) => {
    handelsetdataForm({ ...formdata, userId: data });
    setIdUserCreate(data);
  };

  const setUsemobileCreate = (data) => setMobileUser(data);

  useEffect(() => {
    if (edit) {
      dataFeching();
    } else {
      handelloding(false);
    }
    return () => {};
  }, [idUserCreate]);

  const handelValue = (name, value) => {
    switch (name) {
      case 'userId':
        handelsetdataForm({ ...formdata, userId: value });
        break;
      case 'groupId':
        handelsetdataForm({ ...formdata, groupId: value });
        break;
      case 'workerId':
        handelsetdataForm({ ...formdata, workerId: value });
        break;
      case 'instructionId':
        handelsetdataForm({ ...formdata, instructionId: value });
        break;
      case 'paymentType':
        handelsetdataForm({ ...formdata, paymentType: value });
        break;
      case 'startWork':
        setStartDate(value);
        handelsetdataForm({
          ...formdata,
          startWork: `${value}T${startclock ? startclock : '00:00'}`,
        });
        break;
      case 'startClock':
        setStartclock(value);
        handelsetdataForm({
          ...formdata,
          startWork: `${startDate}T${value}`,
        });
        break;
      case 'periodTime':
        handelsetdataForm({ ...formdata, periodTime: value });
        break;
      case 'isActiveFormOrder':
        handelsetdataForm({ ...formdata, isActive: value });
        break;
      case 'confirmByCustomer':
        handelsetdataForm({ ...formdata, confirmByCustomer: value });
        break;
      case 'ignoreFormOrder':
        handelsetdataForm({ ...formdata, ignore: value });
        break;
      case 'description':
        handelsetdataForm({ ...formdata, description: value });
        break;
      case 'workerDescription':
        handelsetdataForm({ ...formdata, workerDescription: value });
        break;
      case 'isFavorite':
        handelsetdataForm({ ...formdata, isFavorite: value });
        break;
      case 'orderType':
        handelsetdataForm({ ...formdata, orderType: value });
        break;
      case 'complimentDescription':
        handelsetdataForm({ ...formdata, complimentDescription: value });
        break;
      case 'equipmentDescription':
        handelsetdataForm({ ...formdata, equipmentDescription: value });
        break;
      case 'workDescription':
        handelsetdataForm({ ...formdata, workDescription: value });
        break;
      case 'customAmountType':
        handelsetdataForm({ ...formdata, customAmountType: value });
        break;
      case 'commission':
        handelsetdataForm({ ...formdata, commission: parseInt(value) });
        break;
      case 'additionalAmount':
        handelsetdataForm({
          ...formdata,
          additionalAmount: value !== 0 ? value : 0,
        });
        break;
      case 'isRepeatFormOrder':
        handelsetdataForm({ ...formdata, isRepeat: value });
        break;
      case 'commissionAmount':
        handelsetdataForm({ ...formdata, commissionAmount: value });
        break;
      case 'isAutoFindWorker':
        handelsetdataForm({ ...formdata, isAutoFindWorker: value });
        break;
      case 'orderFacilityIds':
        handelsetdataForm({ ...formdata, orderFacilityIds: value });
        break;
      case 'customGroupDiscount':
        handelsetdataForm({
          ...formdata,
          customGroupDiscount:
            value !== 0 && value !== undefined && value !== null && value !== ''
              ? value
              : 0,
        });
        break;
      case 'discountCopounAmount':
        handelsetdataForm({
          ...formdata,
          discountCopounAmount:
            value !== 0 && value !== undefined && value !== null && value !== ''
              ? value
              : 0,
        });
        break;
      case 'hasNoGroupDiscount':
        handelsetdataForm({ ...formdata, hasNoGroupDiscount: value });
        break;
      case 'newAddressId':
        handelsetdataForm({ ...formdata, newAddressId: value });
        setAddressId(value);
        break;
      case 'newSectionId':
        handelsetdataForm({ ...formdata, newSectionId: value });
        break;
      case 'userAddressSectionBusinessGroupId':
        handelsetdataForm({
          ...formdata,
          userAddressSectionBusinessGroupId: value,
        });
        break;
      case 'specialOrderMissionDetailId':
        handelsetdataForm({ ...formdata, specialOrderMissionDetailId: value });
        break;
      case 'servicePointOn':
        handelsetdataForm({ ...formdata, servicePointOn: value });
        break;
      case 'servicePointOff':
        handelsetdataForm({ ...formdata, servicePointOff: value });
        break;
      case 'needServicePointOn':
        handelsetdataForm({
          ...formdata,
          needServicePointOn: value,
          servicePointOn: value ? [] : formdata?.servicePointOn,
        });
        break;
      case 'needServicePointOff':
        handelsetdataForm({
          ...formdata,
          needServicePointOff: value,
          servicePointOff: value ? [] : formdata?.servicePointOff,
        });
        break;
      default:
        break;
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();

    if (!formdata.userId && formdata.orderType !== 5) {
      toast.error('لطفا نام مشتری را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.groupId && formdata.orderType !== 5) {
      toast.error('لطفا گروه را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!startDate && formdata.orderType !== 5) {
      toast.error('لطفا ساعت روز شروع را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!startclock && formdata.orderType !== 5) {
      toast.error('لطفا ساعت روز شروع را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.startWork && formdata.orderType !== 5) {
      toast.error('لطفا تاریخ و روز شروع را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.paymentType && formdata.orderType !== 5) {
      toast.error('لطفا نوع پرداخت را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dataUpdate?.userId ? setConfirmModal(true) : handelSend();
    }
  };

  // FormAddCoustumer
  const [showAddcustomer, setShowAddcustomer] = useState(false);

  const handelCloseCustomer = () => setShowAddcustomer(false);

  // getinvoice
  const [editMode, setEditMode] = useState(false);

  const [invoiceData, setInvoiceData] = useState({});

  const handelgetinvoice = async () => {
    const dataForm = {
      // customAmountMaleWorker: formdata.customAmountMaleWorker,
      // customAmountFemaleWorker: formdata.customAmountFemaleWorker,
      priceListId: formdata.priceListId,
      userId: formdata.userId,
      groupId: formdata.groupId,
      startWork: formdata.startWork,
      periodTime: formdata.periodTime,
      numberMaleWorker: formdata.numberMaleWorker,
      numberFemaleWorker: formdata.numberFemaleWorker,
      additionalAmount: formdata.additionalAmount,
      commission: formdata.commission,
      commissionAmount: formdata.commissionAmount,
      orderFacilityIds: formdata.orderFacilityIds,
      orderType: formdata.orderType,
      orderOptions: formdata.orderOptions,
      customGroupDiscount: formdata.customGroupDiscount,
      discountCopounAmount: formdata.discountCopounAmount,
      hasNoGroupDiscount: formdata.hasNoGroupDiscount,
      orderScheduleId: formdata.id,
    };

    handelLoadingform(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/BusinessToBusinessOrder/getinvoice`,
        JSON.stringify(dataForm),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data.data;
      handelLoadingform(false);
      setInvoiceData(data);
    } catch (error) {
      handelerrors(error);
      handelLoadingform(false);
    }
  };

  const [groupIdForSupervisor, setGroupIdForSupervisor] = useState('');

  useEffect(() => {
    const getServicesByUserId = async () => {
      try {
        const res = await Axios.get(
          `${urldashboard}/B2BGroup/getByAddressSectionIdDropdown/${formdata?.newSectionId}/${formdata?.userId}`,
          {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json; charset=utf-8 ',
            },
          }
        );
        const data = res.data.data;
        setGroupIdForSupervisor(
          data?.find((item) => item?.groupId === formdata?.groupId)
            ?.addressSectionBusinessGroupId
        );
      } catch (error) {
        return null;
      }
    };

    if (formdata?.userId && formdata?.groupId && formdata?.newSectionId) {
      getServicesByUserId();
    }
  }, [formdata?.groupId]);

  const handelPutDataAmountPerHourInfo = (data) => {
    // formdata.customAmountMaleWorker = data?.price
    //   ? data?.price?.replaceAll(',', '')
    //   : null;
    formdata.priceListId = data?.priceListId ?? null;
    handelsetdataForm({ ...formdata, ...data });
  };

  const [capacityMessage, setCapacityMessage] = useState(null);

  useEffect(() => {
    const getServicesByUserId = async () => {
      try {
        const res = await Axios.get(
          `${urldashboard}/servicePoint/getCapacity?addressId=${
            formdata?.newAddressId
          }&numberOfWorkers=${
            parseInt(formdata?.numberMaleWorker ?? 0) +
            parseInt(formdata.numberFemaleWorker ?? 0)
          }`,
          {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json; charset=utf-8 ',
            },
          }
        );
        const data = res.data.data;
        setCapacityMessage(data);
      } catch (error) {
        return null;
      }
    };

    if (
      formdata?.newAddressId &&
      (formdata?.numberMaleWorker || formdata?.numberFemaleWorker)
    ) {
      getServicesByUserId();
    }
  }, [
    formdata?.newAddressId,
    formdata?.numberMaleWorker,
    formdata.numberFemaleWorker,
  ]);

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form>
          {!dataUpdate?.userId ? (
            <Form.Row>
              <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                <InputControlAsync
                  url='/userManagement/B2BSearchDropdown'
                  label='نام مشتری'
                  name='userId'
                  idSelect={idUserCreate}
                  defaultValue={MobileUser}
                  handelValue={handelValue}
                />
              </Col>

              {formdata?.userId && (
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url={`/B2BAddress/getDropDown?substituteUserId=${formdata?.userId}`}
                    label='آدرس‌'
                    name='newAddressId'
                    handelValue={handelValue}
                  />
                </Col>
              )}
              {formdata?.userId && formdata?.newAddressId && (
                <Col xl={4} lg={8} md={12} sm={12} xs={24}>
                  <InputControl
                    url={`/addressSection/getByAddressIdDropdown/${formdata?.newAddressId}/${formdata?.userId}`}
                    label='بخش‌'
                    name='newSectionId'
                    handelValue={handelValue}
                  />
                </Col>
              )}
              {formdata?.userId && formdata?.newAddressId && formdata?.newSectionId && (
                <Col xl={4} lg={8} md={12} sm={12} xs={24}>
                  <InputControl
                    url={`/B2BGroup/getByAddressSectionIdDropdown/${formdata?.newSectionId}/${formdata?.userId}`}
                    label='خدمت‌'
                    name='groupId'
                    handelValue={handelValue}
                    isAnException
                  />
                </Col>
              )}
              {formdata?.userId && formdata?.newAddressId && formdata?.groupId && groupIdForSupervisor && (
                <Col xl={4} lg={8} md={12} sm={12} xs={24}>
                  <InputControl
                    url={`/B2BUser/getByAddressSectionBusinessGroupDropdown/${groupIdForSupervisor}/${formdata?.userId}`}
                    label='سرپرست بخش'
                    name='userAddressSectionBusinessGroupId'
                    handelValue={handelValue}
                  />
                </Col>
              )}
            </Form.Row>
          ) : (
            <>
              <Form.Row>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ width: '100%' }}
                >
                  <Descriptions title='اطلاعات آدرس مشتری' bordered column={4}>
                    <Descriptions.Item label='آدرس'>
                      {dataUpdate?.addressName ?? 'اطلاعات وارد نشده'}
                    </Descriptions.Item>
                    <Descriptions.Item label='بخش'>
                      {dataUpdate?.addressSectionName ?? 'اطلاعات وارد نشده'}
                    </Descriptions.Item>
                    <Descriptions.Item label='خدمت'>
                      {dataUpdate?.businessGroupTitle ?? 'اطلاعات وارد نشده'}
                    </Descriptions.Item>
                    <Descriptions.Item label='نام مسئول'>
                      {dataUpdate?.foremanName ?? 'اطلاعات وارد نشده'}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Form.Row>
              <Divider />
            </>
          )}

          <Form.Row style={{ marginBottom: '2rem' }}>
            <Col lg='4' md='4' sm='6'>
              <InputClock
                label='ساعت شروع'
                name='startClock'
                handelValue={handelValue}
                defaultValue={dataUpdate?.startWork?.split('T')[1]}
              />
            </Col>
            <Col lg='4' md='4' sm='6'>
              <InputDate
                label='تاریخ شروع'
                name='startWork'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate?.hasOwnProperty('startWork')
                    ? dataUpdate?.startWork.split('T')[0]
                    : ''
                }
              />
            </Col>
            {formdata.groupId ? (
              <FormsetGroup
                idGroup={formdata.groupId}
                dataUpdate={{
                  numberFemaleWorker: dataUpdate?.numberFemaleWorker,
                  numberMaleWorker: dataUpdate?.numberMaleWorker,
                  periodTime: dataUpdate?.periodTime,
                }}
                dataArry={dataFromGrpoup}
                handelData={handeldatafromgroup}
                handelpreiod={handelpreiod}
                isEdit={dataUpdate?.userId}
              />
            ) : null}

            {formdata.groupId &&
            formdata.periodTime &&
            startDate &&
            startclock ? (
              <Col lg='4' md='4' sm='6'>
                <B2BAmountPerHourInfo
                  groupId={formdata.groupId}
                  periodTime={formdata.periodTime}
                  startWork={formdata.startWork}
                  appType={formdata.appType}
                  orderScheduleId={formdata.id}
                  setOffEditMode={(flag) => setEditMode(flag)}
                  editMode={dataUpdate?.priceListId !== undefined}
                  handleChange={handelPutDataAmountPerHourInfo}
                  priceListId={dataUpdate?.priceListId}
                  dataUpdate={{
                    customAmountFemaleWorker:
                      dataUpdate?.customAmountFemaleWorker,
                    customAmountMaleWorker: dataUpdate?.customAmountMaleWorker,
                  }}
                />
              </Col>
            ) : null}
          </Form.Row>

          {dataUpdate?.oldOrderOptions ? (
            dataUpdate?.oldOrderOptions.length > 0 ? (
              <Row
                className='mb-2 mt-2 p-3'
                style={{ backgroundColor: '#ffffff', borderRadius: '20px' }}
              >
                <Col
                  className='d-flex text-center align-baseline justify-content-center'
                  md='12'
                  sm='12'
                  lg='12'
                  xs='12'
                >
                  <h3>موارد که در سیستم قبلی انتخاب شده بوده است :</h3>
                </Col>
                {dataUpdate?.oldOrderOptions.map((item, index) => (
                  <Col
                    className='d-flex justify-content-center align-baseline'
                    md='2'
                    lg='2'
                    sm='6'
                    xs='6'
                  >
                    {index + 1} - {item}
                  </Col>
                ))}
              </Row>
            ) : null
          ) : null}
          {formdata.hasOwnProperty('numberMaleWorker') ||
          formdata.hasOwnProperty('numberFemaleWorker') ? (
            <FormGroupoption
              datasend={{
                numberMaleWorker:
                  formdata.numberMaleWorker === undefined
                    ? 0
                    : formdata.numberMaleWorker,
                numberFemaleWorker:
                  formdata.numberFemaleWorker === undefined
                    ? 0
                    : formdata.numberFemaleWorker,
                groupId: formdata.groupId,
              }}
              dataFromGroupOption={dataFromGroupOption}
              handelGroupOption={handelGroupOption}
            />
          ) : null}
          {dataUpdate?.userId ? null : preiod ? (
            <FormPreiod
              datapreiod={datapreiod}
              handelPreiodForm={handelPreiodForm}
            />
          ) : null}
          {dataUpdate?.userId ? null : (
            <Form.Row className='mb-5'>
              <Switchrs
                label='آیا روز های کاری نیرو نادیده گرفته شود؟'
                name='ignoreFormOrder'
                handelValue={handelValue}
                defaultValue={dataUpdate?.ignore}
              />
            </Form.Row>
          )}
          {!dataUpdate?.userId && formdata.newAddressId && (
            <Form.Row
              style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #ddd',
                padding: '2rem',
                marginBottom: '2rem',
              }}
            >
              {capacityMessage !== null && capacityMessage !== undefined && (
                <Col lg={12} style={{ marginBottom: '1rem' }}>
                  <Alert
                    message={`برای این آدرس و این تعداد نیرو، حداکثر تعداد نقطه سرویس انتخابی شما میتواند ${capacityMessage} باشد.`}
                    type='info'
                  />
                </Col>
              )}
              <Col>
                <Switchrs
                  label='آیا مسیر رفت نیاز به نقطه سرویس دارد؟'
                  name='needServicePointOn'
                  handelValue={handelValue}
                  defaultChecked={true}
                />
              </Col>
              <Col>
                <InputControlMulti
                  url={`/servicePoint/getByAddressDropdown?transportationLineType=0&addressId=${
                    formdata?.newAddressId
                  }&hour=${
                    startclock ? parseInt(startclock?.substring(0, 2)) : 0
                  }`}
                  label='نقطه سرویسهای رفت'
                  name='servicePointOn'
                  handelValue={handelValue}
                  isClear={!formdata?.needServicePointOn}
                  disabled={!formdata?.needServicePointOn}
                  dependency={{
                    addressId: formdata.newAddressId,
                    orderStartHour: startclock,
                  }}
                />
              </Col>
              <Col>
                <Switchrs
                  label='آیا مسیر برگشت نیاز به نقطه سرویس دارد؟'
                  name='needServicePointOff'
                  handelValue={handelValue}
                  defaultChecked={true}
                />
              </Col>
              <Col>
                <InputControlMulti
                  url={`/servicePoint/getByAddressDropdown?transportationLineType=1&addressId=${
                    formdata?.newAddressId
                  }&hour=${
                    dataFromGrpoup?.periodTime && startclock
                      ? parseInt(startclock?.substring(0, 2)) +
                          dataFromGrpoup?.periodTime >
                        24
                        ? parseInt(startclock?.substring(0, 2)) +
                          dataFromGrpoup?.periodTime -
                          24
                        : parseInt(startclock?.substring(0, 2)) +
                          dataFromGrpoup?.periodTime
                      : startclock
                      ? parseInt(startclock?.substring(0, 2))
                      : 0
                  }`}
                  label='نقطه سرویسهای برگشت'
                  name='servicePointOff'
                  handelValue={handelValue}
                  isClear={!formdata?.needServicePointOff}
                  disabled={!formdata?.needServicePointOff}
                  dependency={{
                    addressId: formdata.newAddressId,
                    orderStartHour: startclock,
                    orderEndHour: dataFromGrpoup?.periodTime,
                  }}
                />
              </Col>
            </Form.Row>
          )}
          <Form.Row>
            {startDate && (formdata?.userId || dataUpdate?.userId) && (
              <Col>
                <InputControlMulti
                  url={
                    datapreiod?.endWork
                      ? `/orderFacility/orderFacilityDropdown?fromDate=${startDate}&toDate=${
                          datapreiod?.endWork
                        }&userId=${
                          formdata?.userId || dataUpdate?.userId
                        }&orderFacilityType=0`
                      : `/orderFacility/orderFacilityDropdown?fromDate=${startDate}&userId=${
                          formdata?.userId || dataUpdate?.userId
                        }&orderFacilityType=0`
                  }
                  label='امکانات سفارش'
                  name='orderFacilityIds'
                  disabled={!startDate}
                  handelValue={handelValue}
                  defaultValue={dataUpdate?.orderFacilityIds}
                  dependency={{
                    startDate: startDate,
                    endDate: datapreiod?.endWork,
                    userId: formdata?.userId,
                  }}
                />
              </Col>
            )}

            <Col>
              <InputControl
                url='/instruction/dropdown'
                label='دستور عمل سفارش'
                name='instructionId'
                handelValue={handelValue}
                defaultValue={dataUpdate?.instructionId}
              />
            </Col>

            {startDate && formdata?.groupId && (
              <Col>
                <InputControl
                  isPost
                  label='سفارش خاص'
                  name='specialOrderMissionDetailId'
                  handelValue={handelValue}
                  url='/specialOrderMission/getDetailDropdown'
                  defaultValue={dataUpdate.specialOrderMissionDetailId}
                  dependency={{
                    orderStartDate: startDate,
                    groupId: formdata?.groupId,
                  }}
                  command={{
                    orderStartDate:
                      formdata?.startWork ?? dataUpdate?.startWork,
                    groupId: formdata?.groupId ?? dataUpdate?.groupId,
                    bussinessType: 1,
                  }}
                />
              </Col>
            )}

            <Col>
              <InputControl
                url='/common/paymenttypedropdown'
                label=' نوع پرداخت'
                name='paymentType'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate?.paymentType
                    ? dataUpdate?.paymentType
                    : formdata.paymentType
                }
                disabled
              />
            </Col>

            <Col>
              <InputControl
                url='/common/ordertypedropdown'
                label='نوع سفارش'
                name='orderType'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate?.orderType
                    ? dataUpdate?.orderType
                    : formdata.orderType
                }
                disabled
              />
            </Col>
            <Col>
              <InputPricing
                label='تخفیف فاکتور'
                name='discountCopounAmount'
                handelValue={handelValue}
                defaultValue={dataUpdate?.discountCopounAmount?.toString()}
              />
            </Col>
            <Col>
              <InputPricing
                label='مبلغ دلخواه تخفیف محصول'
                name='customGroupDiscount'
                handelValue={handelValue}
                defaultValue={dataUpdate?.customGroupDiscount?.toString()}
              />
            </Col>
            <Switchrs
              label='نمیخواهم تخفیف محصول اعمال شود'
              name='hasNoGroupDiscount'
              handelValue={handelValue}
              checke={formdata.hasNoGroupDiscount}
            />
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label htmlFor='descriptionTextarea'>توضیحات مخصوص کاربر</label>
                <textarea
                  className='form-control'
                  id='descriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate?.description : ''}
                  onChange={(e) => handelValue('description', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label
                  htmlFor='workDescriptionTextarea'
                  style={{ fontSize: '15px' }}
                >
                  شرح کار
                </label>
                <textarea
                  className='form-control'
                  id='workDescriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate?.workDescription : ''}
                  onChange={(e) =>
                    handelValue('workDescription', e.target.value)
                  }
                  style={{ borderWidth: '2px' }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label
                  htmlFor='equipmentDescriptionTextarea'
                  style={{ fontSize: '15px' }}
                >
                  پوشش تجهیزات مورد نیاز
                </label>
                <textarea
                  className='form-control'
                  id='equipmentDescriptionTextarea'
                  rows='6'
                  defaultValue={
                    dataUpdate ? dataUpdate?.equipmentDescription : ''
                  }
                  onChange={(e) =>
                    handelValue('equipmentDescription', e.target.value)
                  }
                  style={{ borderWidth: '2px' }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label
                  htmlFor='complimentDescriptionTextarea'
                  style={{ fontSize: '15px' }}
                >
                  توضیحات
                </label>
                <textarea
                  className='form-control'
                  id='complimentDescriptionTextarea'
                  rows='6'
                  defaultValue={
                    dataUpdate ? dataUpdate?.complimentDescription : ''
                  }
                  onChange={(e) =>
                    handelValue('complimentDescription', e.target.value)
                  }
                  style={{ borderWidth: '2px' }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label
                  htmlFor='workerDescriptionTextarea'
                  style={{ fontSize: '15px' }}
                >
                  توضیحات قابل نمایش برای نیرو
                </label>
                <textarea
                  className='form-control'
                  id='workerDescriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate?.workerDescription : ''}
                  onChange={(e) =>
                    handelValue('workerDescription', e.target.value)
                  }
                  style={{ borderWidth: '2px' }}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row className='mt-2 mb-5'>
            <Switchrs
              label='آیا فعال باشد؟'
              name='isActiveFormOrder'
              handelValue={handelValue}
              checke={formdata.isActive}
            />
            <Switchrs
              label='جستجوی خودکار نیرو'
              name='isAutoFindWorker'
              handelValue={handelValue}
              checke={formdata.isAutoFindWorker}
            />
            {
              <Switchrs
                label=' نیاز به تایید کاربر prm دارد؟'
                name='confirmByCustomer'
                handelValue={handelValue}
                checke={formdata.confirmByCustomer}
              />
            }

            {dataUpdate?.userId ? (
              <Switchrs
                label='آیا سفارش تکراری است؟'
                name='isRepeatFormOrder'
                handelValue={handelValue}
                checke={formdata.isRepeat}
              />
            ) : null}
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm || !formdata.priceListId}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate?.userId ? (
                  'ثبت ویرایش'
                ) : (
                  'ثبت'
                )}
              </button>
            </Col>
            <Col>
              <Button
                // disabled={LoadingForm}
                disabled={
                  formdata.userId && formdata.groupId && formdata.startWork
                    ? false
                    : true
                }
                onClick={handelgetinvoice}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : invoiceData.hasOwnProperty('additionalAmount') ? (
                  'محاسبه مجدد فاکتور'
                ) : (
                  'مشاهده فاکتور'
                )}
              </Button>
            </Col>
          </Form.Row>
          <Form.Row className='mt-4'>
            {invoiceData.hasOwnProperty('additionalAmount') ? (
              <Col
                lg='6'
                md='6'
                sm='6'
                xs='6'
                className='mx-auto p-4'
                style={{ border: '1px solid gray', backgroundColor: 'white' }}
              >
                <p>
                  دسته بندی : <span>{invoiceData.groupTitle}</span>
                </p>
                <p>
                  تاریخ شروع : <span>{invoiceData.persianStartWork}</span>
                </p>
                <p>
                  مقدار هزینه برای نیروی خانم :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.femaleAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  مقدار هزینه برای نیروی آقا :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.maleAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  {' '}
                  هزینه های اضافی :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.additionalAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  هزینه خدمات اضافی :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.propertyAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  امکانات سفارش :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.facilityAmounts)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  مقدار کل تخفیف برای نیروی خانم :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.femaleDiscountAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  {' '}
                  مقدار کل تخفیف برای نیروی آقا:{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.maleDiscountAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  مبلغ تخفیف خدمات اضافه :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.propertyDiscount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  کل تخفیف :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.totalDiscountAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  کل هزینه :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.totalAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>
                  مبلغ قابل پرداخت :{' '}
                  <span>
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(invoiceData.payableAmount)}
                  </span>{' '}
                  <small>ريال</small>
                </p>
                <p>موارد انتخاب شده :</p>
                {invoiceData.orderGroupOptions.map((item) => (
                  <p>
                    {item.title} ({item.value}){' '}
                    {new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(item.price)}{' '}
                    <small>ريال</small>{' '}
                  </p>
                ))}
              </Col>
            ) : null}
          </Form.Row>
        </Form>
      )}
      {showAddcustomer ? (
        <ModalAddCoustmer
          show={showAddcustomer}
          handleClose={handelCloseCustomer}
          setiduserCrate={setiduserCrate}
          setUsemobileCreate={setUsemobileCreate}
        />
      ) : null}

      <Modal
        title={'ویرایش سفارش'}
        width={500}
        open={confirmModal}
        onCancel={() => setConfirmModal(false)}
        closable={false}
        footer={[
          <div style={{ width: '100%', display: 'flex', gap: '10px' }}>
            <Button
              disabled={LoadingForm}
              block
              key='submit'
              onClick={() => handelUpdataFrom()}
              className='btn btn-primary rounded-0'
            >
              {LoadingForm ? (
                <i className='fa fa-spinner fa-pulse fa-fw'></i>
              ) : (
                'بله'
              )}
            </Button>
            <Button
              block
              key='back'
              style={{ margin: 0 }}
              onClick={() => setConfirmModal(false)}
              className='btn btn-secondary rounded-0'
            >
              خیر
            </Button>
          </div>,
        ]}
      >
        <Row gutter={20} align={'middle'}>
          <Col
            xl='12'
            lg='12'
            md='12'
            sm='12'
            xs='12'
            style={{ textAlign: 'start', marginBottom: '2rem' }}
          >
            <p>احتمال دارد نیرو از سفارش حذف شود.</p>
            <p>احتمال دارد نقطه سرویس حذف گردد.</p>
            <p>
              احتمال دارد ساعت سفارش از حالت متعارف به غیر متعارف و یا بالعکس
              تغییر کند.
            </p>
          </Col>
          <Col xl='12' lg='12' md='12' sm='12' xs='12'>
            <h3>آیا اطمینان دارید؟</h3>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default FormOrder;
